module.exports = __webpack_public_path__ + "img/section2-boxImg.8b121968.png";